module.exports = __webpack_public_path__ + "img/notice.13e25e27.jpg";